import { render, staticRenderFns } from "./lounge-pass-additional-traveller-card.vue?vue&type=template&id=588f42f7&scoped=true"
import script from "./lounge-pass-additional-traveller-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./lounge-pass-additional-traveller-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./lounge-pass-additional-traveller-card.vue?vue&type=style&index=0&id=588f42f7&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f42f7",
  null
  
)

export default component.exports